import React from "react";
import { useNavigate } from "react-router-dom";
import "./Sidebar.style.css";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Icons } from "../../config/MuiIcons.config";

const NavigationCard = ({
  Icon,
  ActiveIcon,
  Path,
  Title,
  Active,
  Action,
  Open,
  SetCollapseMenu,
  IsMenuOpen,
  IsNestedMenu,
}) => {
  const navigation = useNavigate();
  const handleNavigation = () => {
    navigation(Path);
    SetCollapseMenu();
  };

  return (
    <ListItem
      sx={{ display: "block", width: "100%" }}
      className="custom-list-item"
    >
      <ListItemButton
        className={
          Active
            ? "sidebar-menu list-item-btn-active custom-list-button"
            : "sidebar-menu list-item-btn custom-list-button"
        }
        sx={{
          justifyContent: Open ? "initial" : "center",
          borderRadius: "12px",
        }}
        onClick={Action ? Action : handleNavigation}
      >
        <ListItemIcon
          className="custom-list-icon"
          sx={{
            minWidth: 0,
            mr: 1.5,
          }}
        >
          {Active ? ActiveIcon : Icon}
        </ListItemIcon>
        <ListItemText
          primary={Title}
          className="custom-list-text"
          sx={{
            opacity: Open ? 1 : 0,
          }}
          style={{
            color: Active ? "#fff" : "#828282",
            textWrap: "wrap",
          }}
        />
        {IsNestedMenu && Open ? (
          IsMenuOpen ? (
            <Icons.ExpandLessIcon sx={{ color: "GrayText" }} />
          ) : (
            <Icons.ExpandMoreIcon sx={{ color: "GrayText" }} />
          )
        ) : null}
      </ListItemButton>
    </ListItem>
  );
};

export default NavigationCard;
